module.exports = __webpack_public_path__ + "media/images/pages/secondary-senior-leaders/invest_in_your_teachers-ffaea3028018b418dcffaeeaad46653e.svg";